module.exports = __webpack_public_path__ + "img/person_mourong.928bd125.jpg";